export enum Gender {
	MALE = "M",
	FEMALE = "F",
};

export const genderMessages = {
	[Gender.MALE]: "Masculino",
	[Gender.FEMALE]: "Feminino",
};
